/**
 * Use Settings Hook
 *
 * Custom hook to access the settings context.
 *
 * @since 1.0.0
 */

import { useContext } from '@wordpress/element';

import { SettingsContext } from './context';
import type { SettingsContextValue } from './types';

/**
 * Hook to access settings context
 *
 * @since 1.0.0
 *
 * @return Settings context value.
 */
export const useSettings = (): SettingsContextValue => {
	const context = useContext(SettingsContext);

	if (context === undefined) {
		throw new Error('useSettings must be used within a SettingsProvider');
	}

	return context;
};


